import { render, staticRenderFns } from "./main-layout-component.vue?vue&type=template&id=21fc07bc&scoped=true"
import script from "./main-layout-component.vue?vue&type=script&lang=js"
export * from "./main-layout-component.vue?vue&type=script&lang=js"
import style0 from "./main-layout-component.vue?vue&type=style&index=0&id=21fc07bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc07bc",
  null
  
)

export default component.exports